module.exports = __webpack_public_path__ + "static/trexGif-4f2d92539f0ee2f081ae1e3b3c4369d9.gif";